import React, {Component,PropTypes} from 'react'
import firebase from '../../config/database'
import Indicator from '../Indicator'

class Image extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value:props.value,
        isLoading:false,
        max_size: "20",
        idclinica: "",
    };
    this.handleChange=this.handleChange.bind(this);
    this.submitImageToFirebase=this.submitImageToFirebase.bind(this);
    this.saveImageLinkInFirebase=this.saveImageLinkInFirebase.bind(this);
  }


  findFirestoreRelatedData(){

     
    var db = firebase.app.firestore();
    //COLLECTIONS - GET DOCUMENTS 
    
    var _this=this;
    var user = firebase.app.auth().currentUser;
   
    var database = firebase.app.firestore();


      // GET ID CLINICA

     

             database.collection("usuaris").where("email" , "==" ,user.email).get().then(function(Snapshot) {

                Snapshot.forEach(function(docupdate) {

                    var usuariupdate = docupdate.data();

                    // save the info related to the clinica

                    _this.setState({
                      idclinica: usuariupdate.clinica, 
                     });
                    
                    
                   // GET MAX SIZE 

                   var docRef = db.collection("cliniques").doc(usuariupdate.clinica);

                   docRef.get().then(function(doc) {
                    if (doc.exists) {
                       
                       var currentDocument=doc.data();
                       console.log("Max size for images", currentDocument.max_size_image_upload);
                       _this.setState({
                         max_size: currentDocument.max_size_image_upload, 
                        });

                     } else {
                       // doc.data() will be undefined in this case
                        console.log("No info about max size use default");
                              _this.setState({
                                max_size: 2, 
                               });

                         }
                         }).catch(function(error) {
                    console.log("Error getting document:", error);
                     });
                     

               });

             });  


  }

  saveImageLinkInFirebase(link){
    console.log(link);
    this.setState({isLoading:false});
    this.props.updateAction(this.props.theKey,link);
  }

  submitImageToFirebase(value){
    var _this=this;
    // Create a root reference

    var linkstorage = "imagenes_usuarios/" + _this.state.idclinica + "/";

    var storageRef = firebase.app.storage().ref(linkstorage);

    
    var refFile=new Date().getTime()+".jpg"

    // Create a reference to 'mountains.jpg'
 //   var newImageRef = storageRef.child(refFile);
    var stripedImage=value.substring(value.indexOf('base64')+7, value.length);
/*
    newImageRef.putString(stripedImage, 'base64').then(function(snapshot) {
      console.log('Uploaded a base64 string!');
      _this.saveImageLinkInFirebase(snapshot.downloadURL);
    });
*/
    var uploadTask = storageRef.child(refFile).putString(stripedImage, 'base64');

    uploadTask.on('state_changed', function(snapshot){
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

      if ( snapshot.totalBytes > _this.state.max_size*1024*1024) {
         // Size is bigger than 2MB so we don't update the image 


         _this.setState({
          value: "Fichero demasiado grande",
          isLoading:false
        });
         uploadTask.cancel();
         console.log ('Upload is canceled due to a large file');

      } else {
      console.log('Upload is ' + progress + '% done');
    /*  switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log('Upload is paused');
          break;
        case firebase.storage.TaskState.RUNNING: // or 'running'
          console.log('Upload is running');
          break;
       
      }
      */
    }
    }, function(error) {
      // Handle unsuccessful uploads
      _this.setState({
        value: "Error al cargar el fichero",
        isLoading:false
      });
      console.log('Upload is canceled due to an unknown error');


    }, function() {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
        _this.saveImageLinkInFirebase(downloadURL);
        console.log('File available at', downloadURL);
      });
      
    });




  }

  handleChange(e) {
    this.setState({isLoading:true});
     e.preventDefault();
    console.log("Start processing ....")

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      console.log("Image is in base 64 now.. Upload it");
      this.setState({
        file: file,
        value: reader.result
      });
      this.submitImageToFirebase(reader.result)

    }

    reader.readAsDataURL(file)

  }


  componentDidMount(){
    if(this.props.isFirestore){
      
      this.findFirestoreRelatedData();
    }else{
     
      this.findFirebaseRelatedData();
    }
  }


  render() {
    var imgSrc=this.state.value&&this.state.value.length>4?this.state.value:"../../assets/img/image_placeholder.jpg";
    return (

      <div className="fileinput fileinput-new text-center" data-provides="fileinputaa">
        <div className="fileinput-new thumbnail">
            <img src={imgSrc} alt="..." />
        </div>
        <div className="fileinput-preview fileinput-exists thumbnail"></div>
        <div>
            <span className="btn btn-rose btn-round btn-file">
                <span className="fileinput-new"> imagen {this.props.options[0]} MAX  {this.state.max_size} MB</span>
                <span className="fileinput-exists">Modificar</span>
                <input type="file" style={{width:'2000px'}} id={this.props.theKey} name={this.props.theKey}  onChange={this.handleChange} />
            </span>
            <Indicator show={this.state.isLoading} />
            <a href="#pablo" className="btn btn-danger btn-round fileinput-exists" data-dismiss="fileinput"><i className="fa fa-times"></i> Remove</a>
        </div>
    </div>
    )
  }
}
export default Image;

Image.propTypes = {
    updateAction:PropTypes.func.isRequired,
    theKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    class: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/fields/Image.js